import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Activate from "./pages/Activate";
import Dashboard from "./pages/Dashboard";
import TradeDetail from "./pages/TradeDetail";
import Charts from "./pages/Charts";
import Analytics from "./pages/Analytics";
import Calculator from "./pages/Calculator";
import Settings from "./pages/Settings";

function AppRoutes() {
  const { user, loading, config } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground font-mono text-sm">
        Loading My trading journal…
      </div>
    );
  }

  if (!user) {
    if (window.location.pathname === "/activate") return <Activate />;
    if (config?.app_mode === "multi") return <Login />;
    return (
      <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground text-sm">
        Backend unavailable. Check server logs.
      </div>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/trade/:id" element={<TradeDetail />} />
        <Route path="/charts" element={<Charts />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/calculator" element={<Calculator />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ThemeProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
          <Toaster position="bottom-right" theme="dark" />
        </ThemeProvider>
      </AuthProvider>
    </div>
  );
}
